import '../css/answered_message.css'
import deleteMessage from '../img/delete_message.png'
import Message from './Message';


function AnsweredMessage({answeredMessage, setAnsweredMessage}) {
    return <div className="answered-message-section">
        <div className='answered-message-delete-button-container' onClick={() => setAnsweredMessage(null)}>
            <img className='answered-message-delete-button' src={deleteMessage} alt='error'/>
        </div>
        <div className="answered-message-upper-text">В ответ {answeredMessage?.user?.name}</div>
        <div className="answered-message-text">{answeredMessage?.text}</div>
    </div>
};

export default AnsweredMessage;